import { setTiposPublicacion } from '../actions/tiposPublicacionActions';
import {
    SET_TIPOS_GRUPO_PLANES,
    SET_TIPOS_PUBLICACION,
    FETCH_TIPOS_PUBLICACION,
    FETCH_TIPOS_PUBLICACION_BYID,
    LOADING_TIPOS_PUBLICACION,
    SET_FILTRO_TIPOS_PUBLICACION,
    RESET_FILTRO_TIPOS_PUBLICACION,
    RESET_TIPOS_PUBLICACION,
    RESET_VALUE_CHECKED,
    RESET_SET_TIPO_PUBLICACIONES,
    UPDATE_LIST_TIPOS_PUBLICACIONES,
    IS_LOADED_TIPO_PUBLICACION_IN_SELLER_TAB
} from '../actions/types';
import { filtroEstados } from '../helper/ordenHelper';

const initialState = {
    loadingTiposPublicacion: false,
    tiposPublicacion: {},
    tiposPublicaciones: { elementos: [], total: 0, page: 0, totalPages: 0 },
    setTiposPublicacion: {},
    tiposGruposPlanes: [],
    filtro: [],
    estadoGrupoPlanes: [],
    loadedSellerTabTipo: false,
}

export default function (state = initialState, action) {

    switch (action.type) {


        case RESET_SET_TIPO_PUBLICACIONES:
            return {
                ...state,
                setTiposPublicacion: [],
                loadedSellerTabTipo: false,
            }

        case LOADING_TIPOS_PUBLICACION:
            return {
                ...state,
                loadingTiposPublicacion: action.payload
            };

        case RESET_VALUE_CHECKED:
            return {
                ...state,
                tiposGruposPlanes: []
            };

        case SET_TIPOS_PUBLICACION:
            return {
                ...state,
                setTiposPublicacion: action.payload
            };

        case IS_LOADED_TIPO_PUBLICACION_IN_SELLER_TAB:
            return {
                ...state,
                loadedSellerTabTipo: action.payload
            };

        case FETCH_TIPOS_PUBLICACION:
            return {
                ...state,
                tiposPublicaciones: action.payload.data
            };

        case FETCH_TIPOS_PUBLICACION_BYID:
            const fetchedItem = action.payload.data.elementos && action.payload.data.elementos.length > 0
                ? action.payload.data.elementos[0]
                : {};

            return {
                ...state,
                tiposPublicacion: fetchedItem,
                setTiposPublicacion: fetchedItem
            };

        case SET_TIPOS_GRUPO_PLANES:
            return {
                ...state,
                tiposGruposPlanes: action.payload,
                estadoGrupoPlanes: action.payload
            };

        case RESET_FILTRO_TIPOS_PUBLICACION:
            return {
                ...state,
                tiposPublicaciones: [],
                setTiposPublicacion: {}

            };

        case SET_FILTRO_TIPOS_PUBLICACION:
            return {
                ...state,
                filtro: action.payload
            };

        case RESET_TIPOS_PUBLICACION:
            return {
                ...state,
                tiposPublicaciones: [],
            };
        case UPDATE_LIST_TIPOS_PUBLICACIONES:
            return {
                ...state,
                tiposPublicaciones: action.payload,
            };
        default: return state
    }
}